import {CardBody, Card, Box, VStack, FormLabel, Input, FormControl, Button} from "@chakra-ui/react";
import React, { useState } from "react";
import PropTypes from "prop-types";

function VerifyForm({ initialToken, isLoading, onSubmit }) {
  const [token, setToken] = useState(initialToken);
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(token);
  };

  return (
    <Box as="form" onSubmit={handleSubmit}>
      <Card>
        <CardBody>
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel>Verification code</FormLabel>
              <Input
                name='verify-code'
                type='text'
                value={initialToken}
                onChange={(e) => setToken(e.target.value)}
                placeholder='Enter verification code...'
              />
            </FormControl>

            <Button
              type='submit'
              colorScheme='blue'
              width='100%'
              isLoading={isLoading}
              loadingText='Logging in...'
              mb={4}
            >
              Verify
            </Button>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
}

VerifyForm.propTypes = {
  initialToken: PropTypes.string,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
}

export default VerifyForm;